import * as React from 'react'
import { Helmet } from 'react-helmet'

import QuickWizardLoading from 'src/components/organisms/wizard/QuickWizardLoading'
import { Support } from 'src/components/layout/Support'

export default class QuickWizardLoadingScreen extends React.Component {
  render() {
    const metaTitle = 'Lädt... | Benu'

    return (
      <div>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
        </Helmet>
        <QuickWizardLoading />
        <Support />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/wizard/QuickWizardLoadingScreen.tsx